import { render, staticRenderFns } from "./AddRecord.vue?vue&type=template&id=e9c0030a&scoped=true&"
import script from "./AddRecord.vue?vue&type=script&lang=js&"
export * from "./AddRecord.vue?vue&type=script&lang=js&"
import style0 from "./AddRecord.vue?vue&type=style&index=0&id=e9c0030a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c0030a",
  null
  
)

export default component.exports